<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="0" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-tab-pane name="0" label="基础配置">
          <el-form ref="form" label-width="80px" style="width:40%;margin-top: 5vh;">
            <el-form-item label-width="100px" label="游戏内开关">
              <el-checkbox v-model="tgBaseCfg.lock.android" label="Android" border />
              <el-checkbox v-model="tgBaseCfg.lock.ios" label="IOS" border />
            </el-form-item>
            <el-form-item label-width="100px" label="跳转地址">
              <el-input v-model="tgBaseCfg.url.android" placeholder="Android" />
              <el-input v-model="tgBaseCfg.url.ios" placeholder="IOS" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmitBase">保存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="1" label="分组配置">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel
                  ref="CommonExcelRef"
                  :import-p="'config:userLabel:import'"
                  :export-p="'config:userLabel:export'"
                  :import-method="importBaseCfg"
                  :export-method="exportBaseCfg"
                />
                <clear-cache-apply />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template v-slot:default="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="奖励配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.rewardId">
                    <el-option v-for="item in list[2]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="商品配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.goodsId">
                    <el-option v-for="item in list[3]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="充值配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.rechargeId">
                    <el-option v-for="item in list[4]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" label="免费次数" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.freeTime" placeholder="免费次数" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="邀请次数" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.inviteTime" placeholder="邀请次数" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="转动价格" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.price" placeholder="转动价格" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <el-button size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button type="primary" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10" class="mb8">
                <CommonExcel
                  ref="CommonExcelRef2"
                  :import-p="'config:userLabel:import'"
                  :export-p="'config:userLabel:export'"
                  :import-method="importCfg"
                  :export-method="exportCfg"
                />
              </el-row>
            </div>
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%">
              <el-table-column label="序号" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template v-slot:default="{row}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template v-slot:default="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="提示" :visible.sync="dialog" width="60%">
        <el-table size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <el-table-column label="操作" align="center" width="50">
            <template v-slot:default="{row,$index}"><span> {{ $index + 1 }}</span></template>
          </el-table-column>
          <el-table-column v-if="type === 2" label="权重" align="center" width="120">
            <template v-slot:default="{row}">
              <el-input-number v-model="row.v" :controls="false" :min="1" placeholder="权重" style="width: 80%" />
            </template>
          </el-table-column>
          <el-table-column v-if="type === 2" label="奖励" align="center">
            <template v-slot:default="scope">
              <Reward v-model="scope.row.reward" :limit-type="[15,22,65]" :limit-len="1" />
            </template>
          </el-table-column>

          <el-table-column v-if="type === 3" label="价格" align="center" width="120">
            <template v-slot:default="{row}">
              <el-input-number v-model="row.price" :controls="false" :min="1" placeholder="权重" style="width: 80%" />
            </template>
          </el-table-column>
          <el-table-column v-if="type === 3" label="限购次数" align="center" width="120">
            <template v-slot:default="{row}">
              <el-input-number v-model="row.limit" :controls="false" :min="1" placeholder="权重" style="width: 80%" />
            </template>
          </el-table-column>
          <el-table-column v-if="type === 3" label="奖励" align="center">
            <template v-slot:default="scope">
              <Reward v-model="scope.row.reward" :limit-len="1" />
            </template>
          </el-table-column>

          <el-table-column v-if="type == 4" label="充值类型" align="center">
            <template v-slot:default="{row}">
              <el-select v-model="row.type">
                <el-option v-for="item in payTypeArr" :key="item.val" :value="item.val" :label="item.name" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column v-if="type == 4" label="价格" align="center">
            <template v-slot:default="{row}">
              <el-input-number v-model="row.price" :controls="false" :min="0.01" :precision="2" placeholder="权重" style="width: 80%" />
            </template>
          </el-table-column>
          <el-table-column v-if="type == 4" label="野兽币数量" align="center">
            <template v-slot:default="{row}">
              <el-input-number v-model="row.num" :controls="false" :min="1" placeholder="权重" style="width: 80%" />
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="100">
            <template v-slot:default="{row,$index}">
              <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button size="small" type="primary" @click="addRewardDialogList(type)">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button size="small" @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import {
} from '@/api/config/run-for-money-cfg'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actAuxiliary, actionActAuxiliary, delActAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'

export default {
  name: 'TgTurntable',
  components: { ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      loading: false,
      dialog: false,
      diaLogList: [],
      total: 0,
      list: [],
      type: 1,
      typeArr: { 2: '转盘配置', 3: '商品配置', 4: '充值配置' },
      payTypeArr: [
        { name: 'TON', val: 1 },
        { name: 'Star', val: 2 }
      ],
      baseList: [],
      mapDialog: false,
      mapDialogList: [],
      groupsList: [],
      curClass: 'tgTurntable',
      tgBaseCfg: {
        lock: { android: true, ios: false },
        url: { android: 'https://t.me/Beast_Go_bot/beast_go', ios: '' }
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
      this.initBase()
    },
    initBase() {
      getCommonCfg({ name: 'tgBaseCfg' }).then(res => {
        if (res.data) {
          this.tgBaseCfg = res.data
        }
      })
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
        getCommonCfg({ name: this.curClass }).then(res => {
          if (res.data) {
            this.baseList = res.data
          }
        })
      })
    },
    openDialog(config) {
      this.dialog = true
      this.diaLogList = config
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    handleSaveBase() {
      updateCommonCfg({ name: this.curClass, data: JSON.stringify(this.baseList) }).then(res => {
        this.msgSuccess('保存成功')
      })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.baseList = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[2], goodsId: this.list[3], rechargeId: this.list[4] }, true, 'name', 'id')
        break
      }
    },
    exportBaseCfg() {
      const fileName = 'tg配置'
      const hearer = []
      const excelData = []
      const name = ['tg配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, rewardId: this.list[2], goodsId: this.list[3], rechargeId: this.list[4] }, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, rewardId: '奖励配置', goodsId: '商品配置', rechargeId: '充值配置', freeTime: '免费次数', inviteTime: '邀请次数', price: '转动价格' })
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleDel(index, id) {
      if (id !== 0) {
        delActAuxiliary({ idList: [id] })
      }
      this.list[this.type].splice(index, 1)
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name === sheet) {
            if (this.type !== 4) {
              for (let j = 0; j < excelData[i].sheetData.length; j++) {
                excelData[i].sheetData[j].reward = this.$refs.RewardRef.handleTranToVal(excelData[i].sheetData[j].reward)
              }
            }
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    handleSaveConfig(type) {
      actionActAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => { this.getList() }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      if (type === 2) {
        fileName = '转盘配置'
        for (let i = 0; i < dataArr.length; i++) {
          const row = JSON.parse(JSON.stringify(dataArr[i]))
          for (let j = 0; j < row.length; j++) {
            row[j].reward = this.$refs.RewardRef.handleTranToZH(row[j].reward)
          }
          const tAk = this.$refs.CommonExcelRef.makeExcelData(row, { v: '权重', reward: { name: '奖励', sub: { propsId: '道具', num: '数量', val: '附加值' }}})
          hearer.push(tAk[0])
          excelData.push(tAk[1])
        }
      }
      if (type === 3) {
        fileName = '商品配置'
        for (let i = 0; i < dataArr.length; i++) {
          const row = JSON.parse(JSON.stringify(dataArr[i]))
          for (let j = 0; j < row.length; j++) {
            row[j].reward = this.$refs.RewardRef.handleTranToZH(row[j].reward)
          }
          const tAk = this.$refs.CommonExcelRef.makeExcelData(row, { price: '价格', limit: '限购次数', reward: { name: '奖励', sub: { propsId: '道具', num: '数量', val: '附加值' }}})
          hearer.push(tAk[0])
          excelData.push(tAk[1])
        }
      }
      if (type === 4) {
        fileName = '充值配置'
        for (let i = 0; i < dataArr.length; i++) {
          const row = JSON.parse(JSON.stringify(dataArr[i]))
          const tAk = this.$refs.CommonExcelRef.makeExcelData(row, { price: '价格', num: '野兽币数量' })
          hearer.push(tAk[0])
          excelData.push(tAk[1])
        }
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, groupIds: [], rewardId: 0, freeTime: 0, inviteTime: 0, price: 1 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    addRewardDialogList(index) {
      let row = { v: 0, reward: [] }
      if (index === 3) {
        row = { price: 1, limit: 1, reward: [] }
      }
      if (index === 4) {
        row = { price: 1, num: 1, type: 1 }
      }
      this.diaLogList.push(row)
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    },
    handleChangePrice(row) {
      for (let i = 0; i < this.skuList.length; i++) {
        if (row.price === this.skuList[i].price) {
          row.sku = this.skuList[i].sku
          break
        }
      }
    },
    onSubmitBase() {
      updateCommonCfg({ name: 'tgBaseCfg', data: JSON.stringify(this.tgBaseCfg) }).then(res => {
        this.msgSuccess('保存成功')
      })
    }

  }
}
</script>
